// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.235d6ffa',
  revision: '235d6ffa',
  branch: 'develop',
  date: 'Fri, 24 Apr 2026 09:48:55 GMT'
};